import { ArrowUpRight } from "lucide-react";
import { PRODUCTS, waLink, scrollToId } from "./constants";
import { Reveal, Eyebrow } from "./Reveal";

const Card = ({ p, i }) => {
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <Reveal delay={i * 0.12} className="h-full">
      <article onMouseMove={onMove} className="spot group relative flex h-full flex-col overflow-hidden border border-white/10 bg-[#15100c] transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-2 hover:border-[#FACC15]/60 hover:shadow-[0_30px_60px_-30px_rgba(250,204,21,0.35)]" data-testid={`product-card-${p.slug}`}>
        <div className="clip-corner relative aspect-[4/3] overflow-hidden">
          <img src={p.img} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#15100c] via-transparent to-transparent" />
          <span className="font-mono-x absolute left-4 top-4 bg-[#0c0a09]/80 px-3 py-1 text-[11px] uppercase tracking-[0.2em] text-[#FACC15] backdrop-blur">{p.tag}</span>
          <span className="font-display absolute bottom-2 right-4 text-7xl font-black text-white/10 transition-colors duration-500 group-hover:text-[#FACC15]/30">0{i + 1}</span>
        </div>
        <div className="relative flex flex-1 flex-col p-6 sm:p-8">
          <h3 className="font-display text-3xl font-black uppercase leading-none text-white">{p.name}</h3>
          <p className="mt-4 flex-1 text-sm leading-relaxed text-stone-300 sm:text-base">{p.text}</p>
          <a href={waLink(`Olá, Destak! Gostaria de um orçamento de ${p.name}.`)} target="_blank" rel="noopener noreferrer" data-testid={`product-quote-btn-${p.slug}`} className="btn-yellow mt-8 w-full justify-between">
            Solicitar orçamento <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </div>
      </article>
    </Reveal>
  );
};

export const Products = () => (
  <section id="produtos" className="relative bg-[#0f0b08] py-24 sm:py-32" data-testid="products-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <Eyebrow>Catálogo</Eyebrow>
          <h2 className="font-display mt-5 text-5xl font-black uppercase leading-[0.9] text-white sm:text-6xl lg:text-7xl">Nossos <span className="text-[#FACC15]">produtos</span></h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="text-base text-stone-200 sm:text-lg">Encontre o compensado ideal para sua necessidade.</p>
          <p className="mt-3 text-sm text-stone-400">Trabalhamos com toda a linha de compensados comuns e navais, laminados e plastificados para construção civil, assoalhos para containers, baú e carretas.</p>
          <button onClick={() => scrollToId("calculadora")} data-testid="products-calc-link" className="nav-link font-mono-x mt-5 text-xs uppercase tracking-[0.2em] text-[#FACC15]">Chapa padrão 1,22 × 2,44 m — calcule quantas você precisa →</button>
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
        {PRODUCTS.map((p, i) => <Card key={p.slug} p={p} i={i} />)}
      </div>
    </div>
  </section>
);
